$('.caseslides__inner.enable-slide').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: false,
  dots: true,
  touchThreshold: 100,
  speed: 480,
  pauseOnHover: false,
  mobileFirst: true,
  cssEase: 'cubic-bezier(.37,1.02,.36,1.04)',
  responsive: [
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});

let timeout;
$(window).on('resize', () => {
  // clear/setTimout prevents crazy firing, causing bad performance

  clearTimeout(timeout);
  timeout = setTimeout(() => {
    $('.caseslides').each(function () {
      if (this.classList.contains('caseslides--nocard')) return;

      let max = 0;

      $(this).find('.caseslides__card').each(function () {
        $(this).css('height', '');

        if (window.innerWidth < 680) return;

        let height = $(this).outerHeight();

        if (height > max) {
          max = height;
        }
      }).each(function () {
        max && $(this).css('height', max + 'px');
      })
    })
  }, 100);
}).trigger('resize');
